import { IdToOriginal, Polling } from 'components/common';
import { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { getAllOriginals } from 'utils/legacyEbService';
import useDeepCompareEffect from 'use-deep-compare-effect';
import get from 'lodash/get';

const usePrintsData = (id: string) => {
  const [printsData, setPrintsData] = useState<any>(null);
  const { status, data: all } = useQuery('originals', getAllOriginals, {
    refetchInterval: Polling.slow,
  });

  const idToOriginal: IdToOriginal = useMemo(() => {
    return (all || []).reduce((map, o) => {
      return {
        ...map,
        [o.id]: o,
      };
    }, {});
  }, [all]);

  useDeepCompareEffect(() => {
    const printsData = get(idToOriginal, `${id}.print`, null);
    setPrintsData(printsData);
  }, [idToOriginal, id]);

  return { printsData, status };
};

export default usePrintsData;
